import { render, staticRenderFns } from "./SeatMapPage.vue?vue&type=template&id=13f5ca87&"
import script from "./SeatMapPage.vue?vue&type=script&lang=js&"
export * from "./SeatMapPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports